import { render, staticRenderFns } from "./Cpdetails.vue?vue&type=template&id=7d480098&scoped=true"
import script from "./Cpdetails.vue?vue&type=script&lang=js"
export * from "./Cpdetails.vue?vue&type=script&lang=js"
import style0 from "./Cpdetails.vue?vue&type=style&index=0&id=7d480098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d480098",
  null
  
)

export default component.exports